import { render, staticRenderFns } from "./messageEditor.vue?vue&type=template&id=9d7dfd36"
import script from "./messageEditor.vue?vue&type=script&lang=js"
export * from "./messageEditor.vue?vue&type=script&lang=js"
import style0 from "./messageEditor.vue?vue&type=style&index=0&id=9d7dfd36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports